import { render, staticRenderFns } from "./WorkflowSetting.vue?vue&type=template&id=a04b2050"
import script from "./WorkflowSetting.vue?vue&type=script&lang=js"
export * from "./WorkflowSetting.vue?vue&type=script&lang=js"
import style0 from "./WorkflowSetting.vue?vue&type=style&index=0&id=a04b2050&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports